/**
 * jv.Common.RoleSelect Module
 * ===============================
 *
 * Render a select2 widget for selecting roles. Optionally toggle multiple.
 *
 * Usage in HTML
 * -------------
 * ```
 * <input jv-role-select[="multiple"] [jv-role-select-filter=fn] data-placeholder="Select Recipients" ng-model="scheduleData.recipients" />
 * ```
 *
 * Add `jv-role-select-filter` to provide a function that filters the results using jQuery.map.
 *
 * Add `jv-role-select-allow-clear` to show the clear button (only relevant when a placeholder is specified and not multi).
 *
 * Multiple URL's can be set per page / module
 * -------------------------------------------
 * Add `jv-role-select-url` if you want to allow the employee select URL to be overridden.
 * 
 * If neither the `jv-role-select-url` nor the `.value('url', '')` value is set, it will default to the one provided below.
 */
angular.module('jv.Common.RoleSelect', [])

.config(['$provide', function($provide) {
    $provide.value('url', jvUrls.admin+'/action/user/search?');
}])

.directive('jvRoleSelect', ['$timeout', 'url', function($timeout, url){
    return {
        require: 'ngModel',
        link: function($scope, iElm, iAttrs, controller) {
            var params = '', // not sure what this is for
                filter = $scope.$eval(iAttrs.jvRoleSelectFilter),
                isMultiple = (iAttrs.jvRoleSelect === 'multiple'),
                roleUrl = jvUrls.admin + '/action/role/list?',
                changed = false;
                if (angular.isDefined(iAttrs.jvRoleSelectFetchCloneable) && iAttrs.jvRoleSelectFetchCloneable ==='true') {
                    roleUrl = roleUrl + '&fetchCloneable=true';
                }
                if (angular.isDefined(iAttrs.jvRoleSelectUsereid) && iAttrs.jvRoleSelectUsereid != '') {
                    roleUrl = roleUrl + '&userEId=' + iAttrs.jvRoleSelectUsereid;
                }
                if (angular.isUndefined(iAttrs.jvRoleSelectInactive)) {
                    roleUrl = roleUrl + '&active=true';
                }
            var config = $.extend({},{
                id:'code',
                multiple: isMultiple,
                allowClear: angular.isDefined(iAttrs.jvRoleSelectAllowClear),
                ajax: {
                    quietMillis: 500,
                    url: function() {
                        return roleUrl;
                    },
                    data: function (term, page) {
                        var pageSize = term && 10 || 50,
                            result = {
                                keywords: term,
                                pageSize: pageSize,
                                page: page - 1
                            };
                        if(angular.isFunction(params)){
                            angular.extend(result, params());
                        }else if(angular.isObject(params)){
                            angular.extend(result, params);
                        }

                        return result;
                    },
                    results: function (data, page) { // parse the results into the format expected by Select2 .
                        // since we are using custom formatting functions we do not need to alter remote JSON data
                        var roles = data.roles || [],
                            more = Boolean(roles.length);

                        if (angular.isFunction(filter)) {
                            roles = $.map(roles, filter);
                        }

                        return {
                            results: roles,
                            more: more
                        };
                    }
                },
                formatResult: function (role) {
                    var formatHtml = "<div class='small'><strong>"+ role.label +"</strong></div><div>" + role.code + "</div>"
                    return formatHtml;
                },
                formatSelection: function (role) {
                    return role.label;
                },
                initSelection: function(element, callback) {
                   if (angular.isDefined(controller.$modelValue) && controller.$modelValue && controller.$modelValue !==null) {
                       callback(controller.$modelValue);
                    } else {
                       var data = {};
                       callback(data);
                   }
                }
            }, window._jvPluginDefaults.select2);

            iElm.select2(config).on('change', function(e) {
                changed = true;
                $scope.$apply(function() {
                    var val = e.val;
                    if (iAttrs.jvRoleSelectObj !== undefined && iAttrs.jvRoleSelectObj !== false) {
                        val = iElm.select2('data');
                    }
                    controller.$setViewValue(val);
                });
            });

            $scope.$watch(iAttrs.ngModel, function(roles, oldRoles) {
                if (!changed && ((isMultiple && roles && roles.constructor === Array && roles.length > 0) || (!isMultiple && roles)) ) {
                    iElm.select2('val', roles);
                }
                if (!roles || roles.length === 0) {
                    iElm.select2('val', '');
                }
                changed = false;
            });

            $scope.$on('$destroy', function() {
                iElm.select2('destroy');
            });
        }
    };
}]);
